import { MarketCandleInterval } from '@app/typings/core'

export const candleIntervalMinuteMapping: Record<MarketCandleInterval, number> = {
  '5m': 5,
  '15m': 15,
  '30m': 30,
  '1h': 60,
  '4h': 240,
}
